// src/containers/Receptions/ReceptionList/components/ReceptionFormPopin.tsx
import React from "react";
import { useCommonStyles } from "$containers/CommonStyles/CommonStyles";
import { Popin } from "$components";
import ReceptionForm from "./ReceptionForm";
import { IReceptionFormPopinProps } from "../types";

const ReceptionFormPopin: React.FC<IReceptionFormPopinProps> = ({
  isReadOnly,
  isSaving,
  reception,
  onSubmit,
  onReset,
  open,
  togglePopin,
  onDelete,
  canDelete,
}) => {
  const commonClasses = useCommonStyles();

  return (
    <Popin
      className={commonClasses.ProjectsPage_Popin}
      openPopin={open}
      toggleDrawer={togglePopin}
    >
      <ReceptionForm
        isReadOnly={isReadOnly}
        isSaving={isSaving}
        reception={reception}
        onSubmit={onSubmit}
        onReset={onReset}
        onDelete={onDelete}
        canDelete={canDelete}
      />
    </Popin>
  );
};

export default ReceptionFormPopin;
